import { render, staticRenderFns } from "./ContractASorPreviewModal.vue?vue&type=template&id=122cb12d"
import script from "./ContractASorPreviewModal.vue?vue&type=script&lang=js"
export * from "./ContractASorPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports